import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';
import { LAYOUT } from '../../styles/layout-tokens';

// Public-marketing section primitive: consistent container width + vertical
// rhythm for stacked landing sections (homepage benefits, /extension, etc.).
// Optional centered header (eyebrow + title + subtitle) above `children`.
export function Section({
  eyebrow,
  title,
  subtitle,
  children,
  className,
  width = 'wide',
}: {
  eyebrow?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  className?: string;
  width?: keyof typeof LAYOUT.container;
}) {
  return (
    <section className={cn('py-16 sm:py-20', className)}>
      <div className={cn(LAYOUT.container[width], 'mx-auto', LAYOUT.page.paddingX)}>
        {(eyebrow || title || subtitle) && (
          <div className="max-w-2xl mx-auto text-center space-y-3 mb-12">
            {eyebrow && (
              <span className="text-xs font-semibold uppercase tracking-wider text-violet-600 dark:text-violet-400">
                {eyebrow}
              </span>
            )}
            {title && (
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900 dark:text-zinc-50">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-base sm:text-lg text-zinc-600 dark:text-zinc-400 leading-relaxed">
                {subtitle}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
